import {
    DocumentData,
    QueryDocumentSnapshot,
    collection,
    getCountFromServer,
    getDocs,
    limit,
    orderBy,
    query,
    startAfter,
    where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Task from '../../models/Task';
import { ETaskStatus } from '@leedpulse-monorepo/enums';

async function getTasks(
    offset: number,
    lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>,
    scopedContactId?: string | null,
    status?: ETaskStatus
): Promise<{
    tasks: Task[];
    lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>;
    totalCollectionCount: number;
}> {
    try {
        const db = firestore;
        const tasksCollection = collection(db, FirestoreCollections.tasks);
        const constraints = [];
        if (scopedContactId) {
            constraints.push(where('id_contact', '==', scopedContactId));
        }
        if (status) {
            constraints.push(where('status', '==', status));
        }
        constraints.push(orderBy('timestamp'));
        if (lastVisible) {
            constraints.push(startAfter(lastVisible));
        }

        // Then we get the jobs
        const results = await getDocs(
            query(
                tasksCollection,
                ...constraints,
                limit(offset)
            )
        );

        const tasksSnapshot = await getCountFromServer(
            query(
                tasksCollection,
                ...constraints
            )
        );

        const tasks: Task[] = [];
        results.docs.forEach((doc) => {
            tasks.push(Task.fromFirestore(doc));
        });

        return {
            tasks,
            lastVisible: results.docs[results.docs.length - 1],
            totalCollectionCount: tasksSnapshot.data().count ?? 0,
        };
    } catch (e) {
        console.log('error: ', e);
        throw new GetTasksFailure();
    }
}

export class GetTasksFailure extends Failure {
    constructor(message = 'Unknown error', code = 'unknown-error') {
        super(message, code);
    }
}

export default getTasks;
